import { render, staticRenderFns } from "./BlankHeader.vue?vue&type=template&id=a1a37e52&"
import script from "./BlankHeader.vue?vue&type=script&lang=ts&"
export * from "./BlankHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/ec2-user/environment/xsearch-app/src/components/Header.vue').default})
